import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import {translateAchievementLevel} from '../utils.js';

export default function ({skill_item, skill_low_percentage}) {

    const class_names = classNames('development-skill-item', `development-skill-item-${skill_item.achievement_level}`);
    const higher = Math.round((skill_item.achievement_percentage - skill_low_percentage) / 2);

    return (
        <div className="flex-column flex-h-end">
            <div className={class_names}>
                <div>
                    {translateAchievementLevel(skill_item.achievement_level)}
                </div>
                <div>
                    {` (`}
                    {skill_item.achievement_percentage}
                    {`%)`}
                </div>
                <div>
                    {moment(skill_item.class_date).format('YYYY MMM')}
                </div>
                <div style={{height: higher}}>
                </div>
            </div>
        </div>
    );
}